import React from 'react';
import { Link } from 'react-router-dom';

const Reviews = () => {
  return <div>
    <div>
      <Link to={"/cake/home"} className="text-decoration-none"><button className='btn app-btn-primary mb-3 me-5'>&larr; Back</button></Link>
    </div>
    Review module coming Soon !!!</div>;
};

export default Reviews;
